import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { AnnouncementBanner } from "./components/AnnouncementBanner";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { MarqueeSection } from "./components/MarqueeSection";
import { ServicesSection } from "./components/ServicesSection";
import { EquipmentSection } from "./components/EquipmentSection";
import { StatsSection } from "./components/StatsSection";
import { GallerySection } from "./components/GallerySection";
import { AdvantagesSection } from "./components/AdvantagesSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";

const LandingPage = () => (
  <>
    <AnnouncementBanner />
    <Header />
    <main>
      <HeroSection />
      <MarqueeSection />
      <StatsSection />
      <ServicesSection />
      <EquipmentSection />
      <GallerySection />
      <AdvantagesSection />
      <ContactSection />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
